import React from "react";
import { Link } from "react-router-dom";
import "../components/ErrorPages.css";

const ServiceUnavailable = () => {
  return (
    <div className="notfound-body center-section text-center">
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
        {/* Left Content */}
        <div className="content">
          <h1>503</h1>
          <h2>Service Unavailable</h2>
          <p>
            Our servers are taking a short break.
            Thanks for your patience — please refresh the page or try again later.
          </p>

          <div className="buttons">
            <Link to="/" className="btn btn-primary me-3">Go to Home</Link>
            <Link to="/contact" className="btn btn-outline">Contact Us</Link>
          </div>
        </div>
      </div>

        {/* Right Illustration */}
      <div className="col-md-6">
        <div className="illustration">
          {/* You can replace this with SVG component also */}
          <img className="responsive-img"
            src="/graphics/images/503illustration.svg"
            alt="Service Unavailable"
          />
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default ServiceUnavailable;
